import React, { FC, useCallback, useMemo } from 'react';
import styles from './index.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCommentDots, faAngleLeft } from '@fortawesome/pro-light-svg-icons';
import classNames from 'classnames';
import { useCurrentSidebar, useOpenSidebar, useCloseSidebar } from 'src/shared/InfoSidebar/hooks';
import { SidebarMode } from 'src/shared/InfoSidebar/types';
import SidebarView from 'src/shared/InfoSidebar/SidebarView';
import { Tooltip } from 'src/common';
import { useTranslation } from 'react-i18next';
import TenderComments from './TenderComments';
import { useTenderData } from 'src/models/procurements/Tender/hooks';

export const TenderSidebar: FC = () => {
  const { data: model } = useTenderData();

  const sidebarState = useCurrentSidebar();
  const openSidebar = useOpenSidebar();
  const closeSidebar = useCloseSidebar();
  const { t } = useTranslation();

  const commentsCount = useMemo(() => {
    return (model && model.flatComments.length) || 0;
  }, [model]);

  const openComments = useCallback(() => {
    openSidebar({ id: model?.id || null, mode: SidebarMode.COMMENTS });
  }, [model, openSidebar]);

  return (
    <>
      <div className={classNames(styles.sidebar, { [styles.isOpen]: sidebarState })}>
        <button
          className={classNames(styles.sidebarSwitchButton, styles.tab, { [styles.isActive]: sidebarState })}
          onClick={sidebarState ? closeSidebar : openComments}
        >
          <FontAwesomeIcon icon={faAngleLeft} />
        </button>
        <div className={styles.sidebarNav}>
          <div className={styles.tabs}>
            <Tooltip title={t('Comments.comments')} placement={'topRight'}>
              <button
                onClick={sidebarState?.mode !== SidebarMode.COMMENTS ? openComments : closeSidebar}
                className={classNames(styles.tab, {
                  [styles.isActive]: sidebarState?.mode === SidebarMode.COMMENTS
                })}
              >
                <FontAwesomeIcon icon={faCommentDots} className={styles.icon} />
                {!!commentsCount && <span className={styles.tabCount}>{commentsCount}</span>}
              </button>
            </Tooltip>
          </div>
        </div>
        <SidebarView className={classNames(styles.preview, { [styles.isOpen]: sidebarState })}>
          {sidebarState && sidebarState.mode === SidebarMode.COMMENTS && sidebarState.id && <TenderComments />}
        </SidebarView>
      </div>
    </>
  );
};

export default TenderSidebar;
